module.exports = __webpack_public_path__ + "static/media/not-yet-checked-in.1f5b1b83.svg";